import { type RouteObject } from 'react-router';

import { metadataRoute, pushRoute } from '@@components/Page/detailViewRoutes';
import { ErrorPage } from '@@containers/App/ErrorPage';

export const routes: RouteObject[] = [
    {
        index: true,
        lazy: async () => {
            const { LinkList } = await import('@@routes/externalContent/links/');

            return { Component: LinkList };
        },
    },
    {
        path: 'new',
        lazy: async () => {
            const { LinkSetupPage } = await import('@@routes/externalContent/links');

            return { Component: LinkSetupPage };
        },
    },
    {
        path: ':id',
        lazy: async () => {
            const { LinkDetailPage } = await import('@@routes/externalContent/links');

            return { Component: LinkDetailPage };
        },
        children: [
            {
                index: true,
                lazy: async () => {
                    const { default: Content } =
                        await import('@@routes/externalContent/links/components/Content');

                    return { Component: Content };
                },
                errorElement: <ErrorPage />,
            },
            metadataRoute,
            pushRoute,
        ],
    },
];
